'use client'

import { useState } from 'react'
import { Icon } from '@/components/Icon'
import { Link } from '@/components/Link'
import { Typography } from '@/components/Typography'
import styles from './ArticleDetailFooterItemDay.module.scss'

export type DayItemFooterProps = {
  readonly items: Array<{
    readonly id: string
    readonly model: {
      readonly url: string
      readonly headline: string
    }
  }>
}

export default function WidgetArticleDetailFooterItemDay({
  item,
}: Readonly<{
  item: DayItemFooterProps
}>) {
  const [showLinkCopied, setShowLinkCopied] = useState(false)
  const onCopy = (url: string) => {
    navigator.clipboard.writeText(url)
    setShowLinkCopied(true)
    setTimeout(() => setShowLinkCopied(false), 2000)
  }
  return (
    <>
      {item.items?.map((item, index) => {
        const url = item.model.url

        return (
          <div className={styles.footer} key={index}>
            <Link href={'https://www.facebook.com/share.php?u=' + url} title="Facebook" target="_blank">
              <Icon name="facebook" />
            </Link>
            <Link href={'https://twitter.com/share?url=' + url} title="X" target="_blank">
              <Icon name="x" />
            </Link>
            <a
              className={styles.copy}
              href={url}
              title="Link kopieren"
              onClick={(event) => {
                onCopy(url)
                event.preventDefault()
              }}
            >
              {showLinkCopied && <div>Link kopiert</div>}
              <Icon name="link" />
              <span>{item.model.headline}</span>
            </a>
          </div>
        )
      })}
    </>
  )
}
